import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { api } from '.';
export type AUM = {
	aum_title: string;
	aum_sub_title: string;
	aum_content: string;
	aum_enrollment_date: string;
	aum_update_date: string;
};
export type CEO = {
	ceo_title: string;
	ceo_sub_title: string;
	ceo_name: string;
	ceo_content: string;
	ceo_enrollment_date: string;
	ceo_update_date: string;
	ceo_image_url: string;
};
export type Team = {
	team_pk: string;
	team_position: string;
	team_name: string;
	team_career: string;
};
type GetInfoResType = {
	aum?: AUM;
	ceo?: CEO;
	team?: Team[];
};
export const useGetBasicApi = () => {
	const url = '/v1/front/getBasic';
	return useQuery<AxiosResponse, AxiosError, GetInfoResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};
export const useGetTeamApi = () => {
	const url = '/v1/front/getTeam';
	return useQuery<AxiosResponse, AxiosError, GetInfoResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};
export type Portfolio = {
	portfolio_pk: string;
	portfolio_status: string;
	portfolio_period: string;
	portfolio_image_url: string;
	portfolio_title: string;
	portfolio_content: string;
	photo_file: [];
	logo_image_url: string;
};
type GetPortfolioResType = {
	portfolio?: Portfolio[];
};
export const useGetPortfolioApi = () => {
	const url = '/v1/front/getPortfolio';
	return useQuery<AxiosResponse, AxiosError, GetPortfolioResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};
